<template>
    <button class="pricing__button">
        <svg xmlns="http://www.w3.org/2000/svg" width="19.115" height="17.037" viewBox="0 0 19.115 17.037"><path d="M7604.941,3741.75a1.557,1.557,0,1,0,1.556,1.556A1.563,1.563,0,0,0,7604.941,3741.75Zm7.935,0a1.557,1.557,0,1,0,1.557,1.556A1.563,1.563,0,0,0,7612.876,3741.75Zm-9.726-12.04-.4-1.884h-4.127v1.989h2.539l2,9.628h11.582l2.99-9.733Zm10.136,7.775h-8.525l-1.194-5.787h11.5Z" transform="translate(-7598.628 -3727.826)"/></svg>
        Purchase
    </button>
</template>

<script>
    export default {
        name: 'PricingButton'
    }
</script>

<style lang="scss">
    .pricing__button {
        margin-top: 35px;
        padding: 15px 40px;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        color: #fff;
        display: flex;
        align-items: center;
        svg {
            margin-right: 10px;
        }
    }
    .pricing__button1 {
        margin-top: 81px;
        background: rgb(126, 186, 143);
    }
    .pricing__button2 {
        background: rgb(133, 149, 196);
    }
    .pricing__button3 {
        background: rgb(199, 76, 143);
    }

    @media (max-width: 767px) {
        .pricing__button1 {
            margin-top: 20px;
        }
    }
</style>